"use client";

import { Suspense, type ReactNode } from "react";
import { ProductSort } from "@/components/product/ProductSort";
import { ViewToggle, type ViewMode } from "@/components/product/ViewToggle";
import { ViewerCount } from "@/components/product/ViewerCount";
import { useTranslations } from "next-intl";

export interface ShopToolbarProps {
  total: number;
  onViewChange?: (mode: ViewMode) => void;
  /** Slot for mobile filter button */
  mobileFilters?: ReactNode;
  /** Whether to show the viewer count (social proof) */
  showViewerCount?: boolean;
}

export function ShopToolbar({
  total,
  onViewChange,
  mobileFilters,
  showViewerCount = false,
}: ShopToolbarProps) {
  const t = useTranslations("product");

  return (
    <div className="mb-6 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        {/* Mobile filter toggle */}
        {mobileFilters}

        <p className="text-sm text-brand-muted">
          {t("showing", { count: total })}
        </p>

        {showViewerCount && <ViewerCount />}
      </div>

      <div className="flex items-center gap-3">
        <ViewToggle onChange={onViewChange} className="hidden sm:flex" />
        <Suspense fallback={null}>
          <ProductSort />
        </Suspense>
      </div>
    </div>
  );
}
